const LocalCallingGuide = () => {
  return (
    <svg
      version="1.1"
      className="-mt-1 w-7 h-7 text-[#fff] overflow-hidden vertical-align-middle"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 258 257"
    >
      <path
        fill="transparent"
        stroke="none"
        d=" M193.000000,258.000000 
	C128.666672,258.000000 64.833351,258.000000 1.000017,258.000000 
	C1.000011,172.333359 1.000011,86.666702 1.000006,1.000040 
	C93.666634,1.000027 186.333267,1.000027 278.999939,1.000013 
	C278.999939,86.666626 278.999939,172.333252 278.999969,257.999939 
	C250.500000,258.000000 222.000000,258.000000 193.000000,258.000000 
M218.251312,150.253769 
	C210.597855,141.945572 201.662704,135.473221 191.319855,130.838089 
	C189.869171,130.187973 188.391571,127.833290 188.310623,126.199066 
	C187.973160,119.387283 188.232574,112.548431 188.146729,105.721100 
	C188.013443,95.121803 181.133728,88.247574 170.577087,88.190598 
	C158.752655,88.126778 146.927460,88.133392 135.102921,88.184898 
	C123.914185,88.233635 117.239944,95.001511 117.153214,106.331238 
	C117.103493,112.826141 117.013847,119.325577 117.205254,125.815216 
	C117.286720,128.577576 116.180237,129.717010 113.798912,130.989807 
	C107.521744,134.344910 100.996590,137.571899 95.510422,142.011703 
	C74.239426,159.225784 65.833748,182.148468 66.870003,209.080307 
	C67.366875,221.993698 75.005638,229.754181 88.013184,229.781250 
	C110.163712,229.827347 132.314362,229.812988 154.464966,229.816208 
	C175.616302,229.819290 196.767975,229.883301 217.918808,229.779663 
	C228.329269,229.728653 236.889816,222.620132 237.673706,212.969727 
	C239.555420,189.804138 234.458679,168.644135 218.251312,150.253769 
M87.727753,54.210815 
	C77.208115,59.168388 67.611794,65.459122 60.527321,74.827423 
	C49.155350,89.865387 43.199554,106.328926 49.184250,125.274712 
	C52.158073,134.688950 57.583641,137.375015 66.858330,134.009888 
	C75.293922,130.949219 83.652428,127.620628 91.849319,123.970879 
	C103.374001,118.839355 108.793976,115.673859 102.480690,100.188080 
	C102.355942,99.882088 102.308495,99.545120 102.217651,99.224686 
	C99.894318,91.029770 101.905624,85.794220 109.347992,81.715782 
	C112.089607,80.213356 115.112579,79.085609 118.136246,78.258942 
	C138.967407,72.563736 160.059906,73.456970 181.118454,76.442978 
	C187.305023,77.320206 193.555405,79.004753 199.296326,81.447769 
	C206.404266,84.472504 208.316437,90.278168 205.791336,97.534660 
	C204.917572,100.045639 203.752167,102.455063 202.876755,104.965546 
	C199.959717,113.330978 201.850510,118.086754 209.870575,121.428741 
	C219.844818,125.585052 229.892990,129.581909 240.022766,133.341782 
	C249.436737,136.835968 255.457077,133.607559 257.018860,123.611244 
	C260.830261,99.215942 254.553268,78.364441 234.139526,63.017715 
	C221.500351,53.515789 206.907486,48.434448 191.705872,45.082310 
	C167.990723,39.852833 144.146637,39.055298 120.403481,44.875191 
	C109.645851,47.512093 99.058807,50.844906 87.727753,54.210815 
z"
      />
      <path
        fill="#fff"
        stroke="none"
        d="
M218.473389,150.529266 
	C234.458679,168.644135 239.555420,189.804138 237.673706,212.969727 
	C236.889816,222.620132 228.329269,229.728653 217.918808,229.779663 
	C196.767975,229.883301 175.616302,229.819290 154.464966,229.816208 
	C132.314362,229.812988 110.163712,229.827347 88.013184,229.781250 
	C75.005638,229.754181 67.366875,221.993698 66.870003,209.080307 
	C65.833748,182.148468 74.239426,159.225784 95.510422,142.011703 
	C100.996590,137.571899 107.521744,134.344910 113.798912,130.989807 
	C116.180237,129.717010 117.286720,128.577576 117.205254,125.815216 
	C117.013847,119.325577 117.103493,112.826141 117.153214,106.331238 
	C117.239944,95.001511 123.914185,88.233635 135.102921,88.184898 
	C146.927460,88.133392 158.752655,88.126778 170.577087,88.190598 
	C181.133728,88.247574 188.013443,95.121803 188.146729,105.721100 
	C188.232574,112.548431 187.973160,119.387283 188.310623,126.199066 
	C188.391571,127.833290 189.869171,130.187973 191.319855,130.838089 
	C201.662704,135.473221 210.597855,141.945572 218.473389,150.529266 
M184.050781,159.619629 
	C178.052505,141.258667 161.528107,132.002365 143.853699,137.102829 
	C127.909462,141.703995 118.168152,158.702713 121.972412,175.285950 
	C125.701355,191.540894 142.515625,202.486359 158.773636,199.242203 
	C177.149033,195.575516 187.474701,179.868317 184.050781,159.619629 
z"
      />
      <path
        fill="#fff"
        stroke="none"
        d="
M88.061066,54.036415 
	C99.058807,50.844906 109.645851,47.512093 120.403481,44.875191 
	C144.146637,39.055298 167.990723,39.852833 191.705872,45.082310 
	C206.907486,48.434448 221.500351,53.515789 234.139526,63.017715 
	C254.553268,78.364441 260.830261,99.215942 257.018860,123.611244 
	C255.457077,133.607559 249.436737,136.835968 240.022766,133.341782 
	C229.892990,129.581909 219.844818,125.585052 209.870575,121.428741 
	C201.850510,118.086754 199.959717,113.330978 202.876755,104.965546 
	C203.752167,102.455063 204.917572,100.045639 205.791336,97.534660 
	C208.316437,90.278168 206.404266,84.472504 199.296326,81.447769 
	C193.555405,79.004753 187.305023,77.320206 181.118454,76.442978 
	C160.059906,73.456970 138.967407,72.563736 118.136246,78.258942 
	C115.112579,79.085609 112.089607,80.213356 109.347992,81.715782 
	C101.905624,85.794220 99.894318,91.029770 102.217651,99.224686 
	C102.308495,99.545120 102.355942,99.882088 102.480690,100.188080 
	C108.793976,115.673859 103.374001,118.839355 91.849319,123.970879 
	C83.652428,127.620628 75.293922,130.949219 66.858330,134.009888 
	C57.583641,137.375015 52.158073,134.688950 49.184250,125.274712 
	C43.199554,106.328926 49.155350,89.865387 60.527321,74.827423 
	C67.611794,65.459122 77.208115,59.168388 88.061066,54.036415 
z"
      />
      <path
        fill="transparent"
        d="
M184.170837,160.022766 
	C187.474701,179.868317 177.149033,195.575516 158.773636,199.242203 
	C142.515625,202.486359 125.701355,191.540894 121.972412,175.285950 
	C118.168152,158.702713 127.909462,141.703995 143.853699,137.102829 
	C161.528107,132.002365 178.052505,141.258667 184.170837,160.022766 
M137.886734,187.739670 
	C151.052780,196.602982 167.130936,193.490662 174.691879,180.615158 
	C182.223450,167.789597 177.213776,151.506714 163.745956,145.037750 
	C152.725983,139.744568 139.426224,143.387711 132.415115,153.620026 
	C125.051338,164.367035 126.989059,177.696884 137.886734,187.739670 
z"
      />
      <path
        fill="#fff"
        stroke="none"
        d="
M137.598129,187.514404 
	C126.989059,177.696884 125.051338,164.367035 132.415115,153.620026 
	C139.426224,143.387711 152.725983,139.744568 163.745956,145.037750 
	C177.213776,151.506714 182.223450,167.789597 174.691879,180.615158 
	C167.130936,193.490662 151.052780,196.602982 137.598129,187.514404 
z"
      />
    </svg>
  );
};
export default LocalCallingGuide;
